import api from '@/api/services/api'

const getCurrencies = () => api({
  method: 'get',
  url: '/dictionaries/currencies'
})

const getMeals = () => api({
  method: 'get',
  url: '/dictionaries/meals'
})

const getCategories = () => api({
  method: 'get',
  url: '/dictionaries/categories'
})

const getCountries = () => api({
  method: 'get',
  url: '/dictionaries/countries'
})

const getDocuments = params => api({
  method: 'get',
  url: '/dictionaries/documents',
  params
})

const getEventsTypes = params => api({
  method: 'get',
  url: '/dictionaries/eventsTypes',
  params
})

const getToursTypes = () => api({
  method: 'get',
  url: '/dictionaries/toursTypes'
})

export {
  getCurrencies,
  getMeals,
  getCategories,
  getCountries,
  getDocuments,
  getEventsTypes,
  getToursTypes
}